/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Create_TaskInputs */

const cs_action_create_task = /** @type {(inputs: Action_Create_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit úkol`)
};

const en_action_create_task = /** @type {(inputs: Action_Create_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create task`)
};

/**
* | output |
* | --- |
* | "Create task" |
*
* @param {Action_Create_TaskInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_create_task = /** @type {((inputs?: Action_Create_TaskInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Create_TaskInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_create_task(inputs)
	return cs_action_create_task(inputs)
});